
<div class="spinner-overlay" *ngIf="loading">
  <p-progressSpinner></p-progressSpinner>
</div>

<div class="card flex justify-content-center gap-2">
  <p-toast position="bottom-center"></p-toast>
</div>

<!--
<div>
<button mat-icon-button (click)="addNewNotebookForm = true"><mat-icon>add</mat-icon> Add new notebook</button>
</div>

<div *ngIf="addNewNotebookForm">
<mat-form-field appearance="fill">
  <mat-label>New notebook...</mat-label>
  <input matInput #itemValueN placeholder="Ex. Lettuce">
</mat-form-field>
<button mat-button (click)="addNewNotebook(itemValueN.value)">Save</button>
<button mat-button (click)="(addNewNotebookForm = false)">Cancel</button>
</div>
-->

<ng-container *ngIf="currentPage == 'insertion-point'; then INSERTIONPOINT; else CHECKNOTEBOOK"></ng-container>
<ng-template #INSERTIONPOINT>
  <!--<h3>EStoou no insertion point</h3>-->
</ng-template>

<ng-template #CHECKNOTEBOOK>
  <ng-container *ngIf="currentPage == 'notebooks'; then NOTEBOOKS; else NOTEBOOK"> </ng-container>
  <ng-template #NOTEBOOK>
    <!--<h3>Estou nos notebook</h3>-->
  </ng-template>
  <ng-template #NOTEBOOKS>
    <!--<h3>Estou nos notebooks</h3>-->
  </ng-template>
</ng-template>


<mat-tree [dataSource]="dataSource" [treeControl]="treeControl" cdkDropList #mainList="cdkDropList" (cdkDropListDropped)="drop($event)" [cdkDropListConnectedTo]="getAllIds()">

  <!-- <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding cdkDrag [style.display]="filterOutNote(node) ? 'none' : 'flex'" matTreeNodePaddingIndent="40"> -->
  <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding cdkDrag  [cdkDragDisabled]="!node.level" [cdkDragData]="node"
      [style.display]="filterOutNote(node) ? 'none' : 'flex'" matTreeNodePaddingIndent="40"
      [ngClass]="{'padding-mobile':  (breakPointService.isHandset && node.level), 'root-node': (!node.level), 'hide-icon-on-hover': hideIconButtons() && node.level}"
      [style.font-size]="getNotesFontSize()" [style.line-height]="getNotesLineHeight()" >

    <button mat-icon-button disabled></button>

    <ng-container *ngIf="currentPage == 'insertion-point'; then INSERTIONPOINT_PAGE1; else NOTEBOOK_PAGE1"></ng-container>

    <ng-template #INSERTIONPOINT_PAGE1>
      <span class="flex node-wrap checklist-leaf-node align-self-center">
                  <mat-checkbox [ngStyle]="{'margin-right': node.level ? '8px' : '0', 'margin-top': checkIfItIsLastNodeAndNotOpened(node) ? '-40px':'inherit'}" class="flex align-self-center" [checked]="checklistSelection.isSelected(node)"
                    (change)="todoLeafItemSelectionToggle($event, node)">
                    <mat-icon class="icon-display align-self-center" *ngIf="!node.level">library_books </mat-icon>

                  </mat-checkbox>
                  <span [ngClass]="{'flex-column': checkIfItIsLastNodeAndNotOpened(node), 'hide-inside-icon-on-hover': hideIconButtons()}" class="flex align-self-center align-items-center">
                    <span class="checklist-item-container"  [ngClass]="{'checklist-leaf-node--item--ip': node.level, 'checklist-notebook--item': !node.level, 'hide-inside-icon-on-hover': hideIconButtons() && (!node.level)}"
                      (deferLoad)="includeNodeIdToConnectedList(node); loadImageIfHas(node)" (dblclick)="node.level ? openDialogEditNote(node):openDialogEditNotebook(node)">
                      <mat-icon *ngIf="node.level" class="item-icon drag-icon" style="cursor: move;" cdkDragHandle>drag_indicator</mat-icon>

                      <mat-icon class="item-icon block mb-2 ml-auto mr-auto" style="cursor: pointer;"
                        *ngIf="node.image_path && !imgURLIsLoaded(node)" (click)="openDialogShowImage(node)">image</mat-icon>
                      <!-- <img  *ngIf="node.image_path" [src] = getImSrc() > -->
                      <span *ngIf="node.image_path">
                        <span *ngIf="imgURLIsLoaded(node)">
                          <img class="block mt-4 mb-2 ml-auto mr-auto" [src]=getImgURL(node) style="max-width: 70%;"
                            (click)="openDialogShowImage(node)" />
                        </span>
                      </span>

                      <span class="item-text inline-block mt-1">
                        {{node.item}}
                      </span>

                      <!-- Botão MORE no canto superior direito -->
                      <button *ngIf="node.level" mat-icon-button class=" more-button" [matMenuTriggerFor]="menu"
                          (menuOpened)="resetConfirmDelete()" [matTooltip]="hideIconButtons() ? 'More':''">
                        <mat-icon>more_horiz</mat-icon>
                        <!-- ou more_horiz _vert, dependendo do ícone que você quer -->
                        </button>

                    </span>
                    <button *ngIf="checkIfItIsLastNodeAndNotOpened(node)" mat-icon-button (click)="openDialogNewNote(getParentFlatNode(node))" matTooltip="Add note"><mat-icon>add</mat-icon></button>
                  </span>
      </span>
    </ng-template>

    <ng-template #NOTEBOOK_PAGE1>
      <span [ngClass]="{'flex-column': checkIfItIsLastNodeAndNotOpened(node), 'hide-inside-icon-on-hover': hideIconButtons()}"
            class="flex node-wrap checklist-leaf-node align-self-center align-items-center">
        <mat-icon class="icon-display" style="cursor: pointer;" *ngIf="!node.level"
          [routerLink]="['/notebooks/'+node.id]">library_books</mat-icon>
        <!-- <mat-icon class="item-icon" style="cursor: move;"  cdkDragHandle>drag_indicator</mat-icon> -->
        <span class="checklist-item-container" [ngClass]="{'checklist-leaf-node--item--notebook': node.level, 'checklist-notebook--item': !node.level}"
          [ngStyle]="{'cursor': !node.level ? 'pointer':'auto'}" [routerLink]="!node.level ? ['/notebooks/'+node.id] : []"
          (deferLoad)="includeNodeIdToConnectedList(node); loadImageIfHas(node)" (dblclick)="node.level ? openDialogEditNote(node):openDialogEditNotebook(node)">
          <mat-icon *ngIf="node.level" class="item-icon drag-icon" style="cursor: move;" cdkDragHandle>drag_indicator</mat-icon>

          <mat-icon class="item-icon block mb-2 ml-auto mr-auto" style="cursor: pointer;"
            *ngIf="node.image_path && !imgURLIsLoaded(node)" (click)="openDialogShowImage(node)">image</mat-icon>
          <!-- <img  *ngIf="node.image_path" [src] = getImSrc() > -->
          <span *ngIf="node.image_path">
            <span *ngIf="imgURLIsLoaded(node)">
              <img class="block mt-4 mb-2 ml-auto mr-auto" [src]=getImgURL(node) style="max-width: 70%;"
                (click)="openDialogShowImage(node)" />
            </span>
          </span>

          <!--
          <span class="item-text inline-block mt-1" [innerHTML]="transformTextToParagraphs(node.item)">
          -->
          <span class="item-text inline-block mt-1">
            {{node.item}}
          </span>

          <!-- Botão MORE no canto superior direito -->
          <button *ngIf="node.level" mat-icon-button class="more-button" [matMenuTriggerFor]="menu"
              (menuOpened)="resetConfirmDelete()" [matTooltip]="hideIconButtons() ? 'More':''">
            <mat-icon>more_horiz</mat-icon>
            <!-- ou more_horiz _vert, dependendo do ícone que você quer -->
          </button>

        </span>
        <button *ngIf="checkIfItIsLastNodeAndNotOpened(node)" mat-icon-button (click)="openDialogNewNote(getParentFlatNode(node))" [matTooltip]="hideIconButtons() ? 'Add note':''"><mat-icon>add</mat-icon></button>
      </span>
    </ng-template>

     <div [id] = "node.id" [ngStyle]="{'margin-top': checkIfItIsLastNodeAndNotOpened(node) ? '-40px':'inherit'}" class="dragOnParent" cdkDropList [cdkDropListData]="node" [cdkDropListConnectedTo]="[mainList]" (cdkDropListDropped)="dropAsChild($event)">
     <!-- <button mat-icon-button  (click)="addNewItem(node)"><mat-icon>add</mat-icon></button> -->
     <button mat-icon-button class="hide-icon-button" (click)="openDialogNewNote(node)" [matTooltip]="hideIconButtons() ? 'Add child note':''"><mat-icon>add</mat-icon></button>

     <button mat-icon-button *ngIf="!node.level" class="hide-icon-button" style="margin-left: -15px;"
      [matMenuTriggerFor]="menu" (menuOpened)="resetConfirmDelete()" [matTooltip]="hideIconButtons() ? 'More':''">
      <mat-icon>
        more_horiz
      </mat-icon>
    </button>

     </div>

     <mat-menu #menu="matMenu"  >
      <button mat-menu-item class="" (click)="openDialogNewNote(node)"><mat-icon>note_add</mat-icon>Add child note</button>
      <button *ngIf="!node.level" mat-menu-item class="" (click)="openDialogEditNotebook(node)"><mat-icon>edit</mat-icon>Rename notebook</button>
      <button *ngIf="node.level" mat-menu-item class="" (click)="openDialogEditNote(node)"><mat-icon>edit</mat-icon>Edit note</button>

      <!--
      <button *ngIf="!node.level" mat-menu-item class="" (click)="deleteNotebookWithChild(node)"><mat-icon>delete</mat-icon>Delete notebook</button>
      <button *ngIf="node.level" mat-menu-item class="" (click)="deleteNoteWithouChild(node)"><mat-icon>delete</mat-icon>Delete note</button>
     -->

      <!-- Se estiver no "modo confirmação" -->
      <ng-container *ngIf="confirmDelete; else normalMenu">
        <div class="inline-menu-actions">
          <button mat-menu-item class="btn-confirm" (click)="node.level ? deleteNoteWithouChild(node):deleteNotebookWithChild(node); resetConfirmDelete() ">
            <mat-icon class="btn-confirm" style="font-size:18px;">delete</mat-icon>
            Confirm
          </button>

          <button mat-menu-item (click)="cancelDelete()">
            Cancel
          </button>
        </div>
      </ng-container>

      <!-- Se estiver no "modo normal" -->
      <ng-template #normalMenu>
        <button mat-menu-item (click)="showDeleteConfirm($event)">
          <mat-icon>delete</mat-icon>
           {{node.level ? "Delete note":"Delete notebook"}}
        </button>
      </ng-template>


      <div class="px-3 my-2"><mat-divider></mat-divider></div>
      <button mat-menu-item class="" (click)="setInsertionPoint(node)"><mat-icon>gps_fixed</mat-icon>Set as location for new notes</button>
      <button mat-menu-item class="" (click)="openDialogExport(node)"><mat-icon>cloud_upload</mat-icon>Export from here</button>
      <button mat-menu-item class="" (click)="markToReview(node)"><mat-icon>assignment</mat-icon>Mark to review</button>
      <div class="px-3 my-2"><mat-divider></mat-divider></div>
      <button mat-menu-item (click)="openNotebookPresentation(node)"><mat-icon>slideshow</mat-icon>{{node.level ? 'Present from here' : 'Present notebook'}}</button>
      <button *ngIf="mindMapEnabled" mat-menu-item (click)="openNotebookMindMap(node)"><mat-icon>account_tree</mat-icon>{{node.level ? 'Mind map from here' : 'Mind map notebook'}}</button>
    </mat-menu>


     <!--  <app-delete-button (delete)="handleDelete(node)"></app-delete-button> -->
     <!--<mat-icon [routerLink]="['/notebooks/'+node.id]" routerLinkActive="router-link-active" >input</mat-icon>-->
  </mat-tree-node>


  <mat-tree-node *matTreeNodeDef="let node; when: hasNoContent" matTreeNodePadding [style.display]="filterOutNote(node) ? 'none' : 'flex'"
        [ngClass]="{'padding-mobile':  (breakPointService.isHandset && node.level)}" [style.font-size]="getNotesFontSize()" [style.line-height]="getNotesLineHeight()">

    <!--
      <button mat-icon-button disabled></button>
      <mat-form-field appearance="fill">
      <mat-label>New item...</mat-label>
      <input matInput #itemValue placeholder="Ex. Lettuce">
      </mat-form-field>
      <button mat-button (click)="saveNode(node, itemValue.value)">Save</button>
    -->
  </mat-tree-node>

  <!-- <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding cdkDrag [style.display]="filterOutNote(node) ? 'none' : 'flex'" matTreeNodePaddingIndent="40"> -->
  <mat-tree-node *matTreeNodeDef="let node; when: hasChild"
    cdkDrag  [cdkDragDisabled]="!node.level" [cdkDragData]="node"
    matTreeNodePadding [style.display]="filterOutNote(node) ? 'none' : 'flex'" matTreeNodePaddingIndent="40"
    [ngClass]="{'padding-mobile':  (breakPointService.isHandset && node.level), 'root-node': (!node.level), 'hide-icon-on-hover': hideIconButtons() && node.level}"
    [ngStyle]="{'flex-wrap': (showNotebookNavigation(node)) ? 'wrap':'nowrap'}" [style.font-size]="getNotesFontSize()" [style.line-height]="getNotesLineHeight()">

    <span class="flex">

    <ng-container *ngIf="currentPage == 'insertion-point'; then INSERTIONPOINT_PAGE2; else NOTEBOOK_PAGE2"></ng-container>

    <ng-template #INSERTIONPOINT_PAGE2>


      <button mat-icon-button matTreeNodeToggle class="align-self-center" [attr.aria-label]="'Toggle ' + node.item"
       (click)=expandTheNode(node) [ngStyle]="{'margin-top': checkIfItIsLastNodeAndNotOpened(node) ? '-40px':'inherit'}">
       <mat-icon class="mat-icon-rtl-mirror">
          {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
       </mat-icon>
      </button>

      <span class="flex node-wrap align-self-center" >
                  <mat-checkbox [ngStyle]="{'margin-right': node.level ? '8px' : '0', 'margin-top': checkIfItIsLastNodeAndNotOpened(node) ? '-40px':'inherit'}" class="flex align-self-center" [checked]="checklistSelection.isSelected(node)"
                      [indeterminate]="descendantsPartiallySelected(node) || descendantsAllSelected(node) || isNotebookIndeterminate(node)"
                      (change)="todoItemSelectionToggle($event, node)">
                      <mat-icon class="icon-display" *ngIf="!node.level"
                        (click)="$event.stopPropagation(); $event.preventDefault(); showNotebookNavigation(node) ? backNavigationToNotebook(node):false;"
                        [ngStyle]="{'cursor': showNotebookNavigation(node) ? 'pointer':'auto'}">library_books</mat-icon>
                  </mat-checkbox>
                  <span [ngClass]="{'flex-column': checkIfItIsLastNodeAndNotOpened(node)}"
                      class="flex align-self-center align-items-center">
                    <span  class="checklist-item-container" [ngClass]="{'checklist-leaf-node--item--ip': node.level, 'checklist-notebook--item': !node.level, 'hide-inside-icon-on-hover': hideIconButtons()}"
                      (deferLoad)="includeNodeIdToConnectedList(node); loadImageIfHas(node)" (dblclick)="node.level ? openDialogEditNote(node):openDialogEditNotebook(node)"
                      (click)="showNotebookNavigation(node) ? backNavigationToNotebook(node):false;"
                      [ngStyle]="{'cursor': showNotebookNavigation(node) ? 'pointer':'auto'}">
                      <mat-icon *ngIf="node.level" class="item-icon drag-icon" style="cursor: move;" cdkDragHandle>drag_indicator</mat-icon>

                      <mat-icon class="item-icon block mb-2 ml-auto mr-auto" style="cursor: pointer;"
                        *ngIf="node.image_path && !imgURLIsLoaded(node)" (click)="openDialogShowImage(node)">image</mat-icon>
                      <!-- <img  *ngIf="node.image_path" [src] = getImSrc() > -->
                      <span *ngIf="node.image_path">
                        <span *ngIf="imgURLIsLoaded(node)">
                          <img class="block mt-4 mb-2 ml-auto mr-auto" [src]=getImgURL(node) style="max-width: 70%;"
                            (click)="openDialogShowImage(node)" />
                        </span>
                      </span>

                      <span class="item-text inline-block mt-1">
                        {{node.item}}
                      </span>

                      <!-- Botão MORE no canto superior direito -->
                      <button *ngIf="node.level" mat-icon-button class="more-button" [matMenuTriggerFor]="menu"
                          (menuOpened)="resetConfirmDelete()" [matTooltip]="hideIconButtons() ? 'More':''">
                        <mat-icon>more_horiz</mat-icon>
                        <!-- ou more_horiz _vert, dependendo do ícone que você quer -->
                      </button>

                    </span>
                    <button *ngIf="checkIfItIsLastNodeAndNotOpened(node)" mat-icon-button (click)="openDialogNewNote(getParentFlatNode(node))" [matTooltip]="hideIconButtons() ? 'Add note':''"><mat-icon>add</mat-icon></button>
                  </span>
      </span>
    </ng-template>

    <ng-template #NOTEBOOK_PAGE2>

      <button mat-icon-button matTreeNodeToggle class="align-self-center" [attr.aria-label]="'Toggle ' + node.item"
       (click)=expandOrRouter(node) [ngStyle]="{'margin-top': checkIfItIsLastNodeAndNotOpened(node) ? '-40px':'inherit'}">
       <mat-icon class="mat-icon-rtl-mirror">
          {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
       </mat-icon>
      </button>

      <span [ngClass]="{'flex-column': checkIfItIsLastNodeAndNotOpened(node), 'hide-inside-icon-on-hover': hideIconButtons()}" class="flex node-wrap align-self-center align-items-center">
        <mat-icon class="icon-display" style="cursor: pointer;" *ngIf="!node.level" [style.pointer-events]="'auto'"
          [routerLink]="['/notebooks/'+node.id]" (click)="showNotebookNavigation(node) ? backNavigationToNotebook(node):false">library_books</mat-icon>
        <span class="checklist-item-container" [ngClass]="{'checklist-leaf-node--item--notebook': node.level, 'checklist-notebook--item': !node.level}"
          [ngStyle]="{'cursor': !node.level ? 'pointer':'auto'}" [routerLink]="!node.level ? ['/notebooks/'+node.id] : []"
          (deferLoad)="includeNodeIdToConnectedList(node); loadImageIfHas(node)" (dblclick)="node.level ? openDialogEditNote(node):openDialogEditNotebook(node)"
          (click)="showNotebookNavigation(node) ? backNavigationToNotebook(node):false">
          <mat-icon *ngIf="node.level" class="item-icon drag-icon" style="cursor: move;" cdkDragHandle>drag_indicator</mat-icon>

          <mat-icon class="item-icon block mb-2 ml-auto mr-auto" style="cursor: pointer;"
            *ngIf="node.image_path && !imgURLIsLoaded(node)" (click)="openDialogShowImage(node)">image</mat-icon>
          <!-- <img  *ngIf="node.image_path" [src] = getImSrc() > -->
          <span *ngIf="node.image_path">
            <span *ngIf="imgURLIsLoaded(node)">
              <img class="block mt-4 mb-2 ml-auto mr-auto" [src]=getImgURL(node) style="max-width: 70%;"
                (click)="openDialogShowImage(node)" />
            </span>
          </span>

          <span class="item-text inline-block mt-1">
            {{node.item}}
          </span>

          <!-- Botão MORE no canto superior direito -->
          <button *ngIf="node.level" mat-icon-button class="more-button" [matMenuTriggerFor]="menu"
              (menuOpened)="resetConfirmDelete()" [matTooltip]="hideIconButtons() ? 'More':''">
            <mat-icon>more_horiz</mat-icon>
            <!-- ou more_horiz _vert, dependendo do ícone que você quer -->
          </button>

        </span>
        <button *ngIf="checkIfItIsLastNodeAndNotOpened(node)" mat-icon-button (click)="openDialogNewNote(getParentFlatNode(node))" [matTooltip]="hideIconButtons() ? 'Add note':''"><mat-icon>add</mat-icon></button>
      </span>
    </ng-template>

    <div [id] = "node.id" [ngStyle]="{'margin-top': checkIfItIsLastNodeAndNotOpened(node) ? '-40px':'inherit'}" class="dragOnParent" cdkDropList [cdkDropListData]="node" [cdkDropListConnectedTo]="[mainList]" (cdkDropListDropped)="dropAsChild($event)">

      <!--<button mat-icon-button (click)="addNewItem(node)"><mat-icon>add</mat-icon></button>-->
      <button mat-icon-button  class="hide-icon-button" (click)="openDialogNewNote(node)" [matTooltip]="hideIconButtons() ? 'Add child note':''"><mat-icon>add</mat-icon></button>

      <button mat-icon-button *ngIf="!node.level" class="hide-icon-button" style="margin-left: -15px;" [matMenuTriggerFor]="menu" [matTooltip]="hideIconButtons() ? 'More':''"><mat-icon>more_horiz</mat-icon></button>
    </div>

  </span>

    <div class="notebook-navigation" *ngIf="showNotebookNavigation(node)" >
      <button mat-icon-button class="p-0" style="width: 30px; height: 40px; margin-left:-35px;" (click)="backNavigation(node)"><mat-icon class="icon-display">keyboard_return</mat-icon></button>
      <button  *ngIf="false" mat-icon-button class="p-0" style="width: 30px; height: 40px;" (click)="backNavigationToNotebook(node)" ><mat-icon class="icon-display">library_books</mat-icon></button>
      <span class="note-nav" style="vertical-align: middle; display: inline-block; margin-top: -10px;"  *ngFor="let navNodeItem of getStackNavigationFromNotebook(node); let i = index" >
        <span *ngIf="i" class="just-arrow" style="margin-left: 5px; margin-right: 5px; display: inline-block;"> > </span>
        <button mat-button style="height: 36px; letter-spacing: normal;" class="text-color-secondary p-0 my-0 ml-1 mr-1 min-w-0 underline" (click)="backNavigationToNote(navNodeItem)">{{truncateString(navNodeItem.item)}}</button>
      </span>
    </div>

    <mat-menu #menu="matMenu">
      <button mat-menu-item class="" (click)="openDialogNewNote(node)"><mat-icon>note_add</mat-icon>Add child note</button>
      <button *ngIf="!node.level" mat-menu-item class="" (click)="openDialogEditNotebook(node)"><mat-icon>edit</mat-icon>Rename notebook</button>
      <button *ngIf="node.level" mat-menu-item class="" (click)="openDialogEditNote(node)"><mat-icon>edit</mat-icon>Edit note</button>
      <button *ngIf="!node.level" mat-menu-item class="" (click)="openDialogDeleteNotebook(node)"><mat-icon>delete</mat-icon>Delete notebook</button>
      <button *ngIf="node.level" mat-menu-item class="" (click)="openDialogDeleteNote(node)"><mat-icon>delete</mat-icon>Delete note</button>
     <div class="px-3 my-2"><mat-divider></mat-divider></div>
     <button mat-menu-item class="" (click)="setInsertionPoint(node)"><mat-icon>gps_fixed</mat-icon>Set as location for new notes</button>
     <button mat-menu-item class="" (click)="openDialogExport(node)"><mat-icon>cloud_upload</mat-icon>Export from here</button>
     <button mat-menu-item class="" (click)="markToReview(node)"><mat-icon>assignment</mat-icon>Mark to review</button>
     <div class="px-3 my-2"><mat-divider></mat-divider></div>
     <button mat-menu-item (click)="openNotebookPresentation(node)"><mat-icon>slideshow</mat-icon>{{node.level ? 'Present from here' : 'Present notebook'}}</button>
     <button *ngIf="mindMapEnabled" mat-menu-item (click)="openNotebookMindMap(node)"><mat-icon>account_tree</mat-icon>{{node.level ? 'Mind map from here' : 'Mind map notebook'}}</button>
   </mat-menu>

    <!--<mat-icon [routerLink]="['/notebooks/'+node.id]" routerLinkActive="router-link-active" >input</mat-icon>-->

   <!-- <app-delete-button (delete)="handleDelete(node)"></app-delete-button> -->
  </mat-tree-node>


</mat-tree>

<router-outlet></router-outlet>

<div style="height: 50px">
